// extracted by mini-css-extract-plugin
module.exports = {"pullQuote":"article_pullQuote__2jFvN","mark":"article_mark__3RrFt","text":"article_text__2vKPT","author":"article_author__34tZV"};